import { FormGroup } from '@angular/forms';
import {
  INVALID_FORM_GENERIC_MESSAGE,
  INVALID_FORM_INLINE_FIELDS_THRESHOLD,
  INVALID_FORM_MANY_FIELDS_MESSAGE,
  INVALID_FORM_MESSAGE,
  INVALID_FORM_REQUIRED_FIELDS_PREFIX
} from '../constants/form-validation.constants';

export function getInvalidEnabledFieldLabels(form: FormGroup, fieldLabels: Record<string, string>): string[] {
  return getInvalidEnabledFields(form, fieldLabels).map((field) => field.label);
}

export type InvalidEnabledField = {
  fieldName: string;
  label: string;
};

export function getInvalidEnabledFields(form: FormGroup, fieldLabels: Record<string, string>): InvalidEnabledField[] {
  return Object.keys(form.controls)
    .filter((fieldName) => {
      const control = form.get(fieldName);
      return !!(control && !control.valid && control.enabled);
    })
    .map((fieldName) => ({
      fieldName,
      label: fieldLabels[fieldName] || fieldName
    }));
}

export function logInvalidEnabledControls(form: FormGroup): void {
  Object.keys(form.controls).forEach((fieldName) => {
    const control = form.get(fieldName);
    if (control && !control.valid && control.enabled) {
      console.error(`Invalid field: ${fieldName}`, {
        errors: control.errors,
        value: control.value
      });
    }
  });
}

export function getInvalidFormMessage(invalidFields: string[]): string {
  if (invalidFields.length === 0) {
    return INVALID_FORM_GENERIC_MESSAGE;
  }

  if (invalidFields.length <= INVALID_FORM_INLINE_FIELDS_THRESHOLD) {
    return `${INVALID_FORM_MESSAGE} Please fill in the following required fields: ${invalidFields.join(', ')}.`;
  }

  return INVALID_FORM_MANY_FIELDS_MESSAGE;
}

export function shouldWarnInvalidFields(invalidFields: string[]): boolean {
  return invalidFields.length > INVALID_FORM_INLINE_FIELDS_THRESHOLD;
}

export type InvalidFormState = {
  error: string;
  invalidFields: InvalidEnabledField[];
};

export function buildInvalidFormState(form: FormGroup, fieldLabels: Record<string, string>): InvalidFormState {
  const invalidFields = getInvalidEnabledFields(form, fieldLabels);
  return {
    invalidFields,
    error: invalidFields.length > 0 ? INVALID_FORM_REQUIRED_FIELDS_PREFIX : INVALID_FORM_GENERIC_MESSAGE
  };
}
